import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import ContentsTab   from 'contents_tab';

import ContentsModal from 'contents_modal';

import MainImage     from './main-image';
import ReportScore   from './report-score-view';
import Profiling     from './profiling';
// -------------------------------------------------------

class PostPreview extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      detail: {},
      is_loading: false,
    };
  }
  // -------------------------------------------------------
  
  UNSAFE_componentWillReceiveProps(nextProps) {
    let detail = nextProps.detail;
    
    this.setState({ is_loading: true });
    
    if( nextProps.is_api == true && detail.shortcode != undefined && nextProps.view == true ){
      
      Utils.request.bind(this)('/api/influencer/post_detail', { shortcode: detail.shortcode, project_id: detail.project_id },
        function(res){
          this.setState({ detail: res.body.data, is_loading: false });
        }.bind(this),
      );
      
    } else {
      this.setState({ detail: detail });
      
      setTimeout( function(){ this.setState({ is_loading: false }); }.bind(this), 50);
    }
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let base = this.props.base;
    let detail = this.state.detail;
    
    let tabs = [{ id: 'main', name: <span><i className="material-icons">image</i>投稿</span>,             html: <MainImage base={base} detail={detail} is_loading={this.state.is_loading} /> }];
    
    if( detail.report != undefined && Object.keys(detail.report).length > 0 ){
      if( this.props.is_report !== false ){
        tabs.push({ id: 'list', name: <span><i className="material-icons">assessment</i>レポートスコア</span>,    html: <ReportScore base={base} detail={detail} report_edit={this.props.report_edit} /> });
        tabs.push({ id: 'task', name: <span><i className="material-icons">account_box</i>プロファイリング</span>, html: <Profiling base={base} detail={detail} /> });
      }
    }
    
    let is_tab_show = (tabs.length > 1) ? 'tab-show' : 'tab-hide';
    
    return (
      <div className="post-preview-modal">
        <ContentsModal
          view      = {this.props.view}
          width     = {'calc(100% - 150px)'}
          height    = {'500px'}
          max_width = {700}
          close_ev  = {this.props.close_ev.bind(this, false)}
          html      = {(
            <div className={'post-preview-modal-contents '+ is_tab_show}>
              <div className="post-preview-container">
                <ContentsTab tabs={tabs} font_size={12} className="sub-contents-tab" />
              </div>
            </div>
          )}
        />
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default PostPreview;